export default __webpack_public_path__ + "static/media/notebook-1.60921c68.png";